// Rating stars

/*!
 * Rating functionality
 */

$(document).ready(function () {
  // START CONFIRM RATING AND HIDE CONFIRM BUTTON/MODAL FOOTER and HIDE MODAL FUNCTIONALITY
  // #my-tray rating inside old orders modals
  $(document).on("click", "#my-tray .oceni-obrok .btn-rating-confirm", function () {
    var $button = $(this); // Reference to the confirm button

    // Check if the button is not disabled by class or attribute
    if (!$button.hasClass("disabled") && !$button.prop("disabled")) {
      var $modal = $button.closest(".oceni-obrok");

      // Make the .rating-successful message visible
      $modal.find(".rating-successful").removeClass("d-none");
      $button.closest(".tab-pane-footer").addClass("d-none");
    }

    // Update rating from modal to the order card
    var $modal = $(this).closest(".modal");
    var openerKey = $modal.data("opener"); // Retrieve the stored opener data
    var $openerDiv = $('[data-opener="' + openerKey + '"]'); // The div that triggered the modal

    // Get the count of .rated stars in #origin
    var ratedCount = $modal.find(".star.rated").length;

    // Update stars in #goal based on the ratedCount
    $openerDiv.find(".star").each(function (index) {
      if (index < ratedCount) {
        $(this).addClass("rated");
      } else {
        $(this).removeClass("rated");
      }
    });
  });

  // #desktopRateMeal on homepage
  $(document).on("click", "#desktopRateMeal .btn-rating-confirm", function () {
    var $button = $(this); // Reference to the confirm button

    // Check if the button is not disabled by class or attribute
    if (!$button.hasClass("disabled") && !$button.prop("disabled")) {
      var $modal = $button.closest(".oceni-obrok");

      // Make the .rating-successful message visible
      $modal.find(".rating-successful").removeClass("d-none");
      $button.closest(".btn-group-separate").addClass("d-none");

      $modal.delay(800).fadeOut(200, function () {
        $(this).remove();
      });
    }
  });

  // #mobileRateMeal on homepage
  $(document).on("click", "#mobileRateMeal .btn-rating-confirm", function () {
    var $button = $(this);
    var $modal = $button.closest(".modal");

    if (!$button.hasClass("disabled") && !$button.prop("disabled")) {
      // Show the success message and hide the button
      $modal.find(".rating-successful").removeClass("d-none");

      // Hide the modal footer where the button resides
      $button.closest(".modal-footer").addClass("d-none");

      // Properly use the delay then hide the modal with Bootstrap's method
      setTimeout(function () {
        $modal.modal("hide");
      }, 800);
    }
  });

  // STOP CONFIRM RATING FUNCTIONALITY
  // ***************************************************

  // Reset button click event within oceni-obrok
  $(document).on("click", ".oceni-obrok .btn-rating-reset", function () {
    var $modal = $(this).closest(".oceni-obrok"); // Find the closest oceni-obrok container

    // Deselect all stars and remove rated and selected classes
    $modal.find(".rating-stars .star").removeClass("selected rated");

    // Add 'disabled' class to the .btn-rating-confirm button and set the disabled attribute
    var $confirmButton = $modal.find(".btn-rating-confirm");
    $confirmButton.addClass("disabled").prop("disabled", true);
  });

  // Rating star click event
  $(document).on("click", ".oceni-obrok .rating-stars .star", function () {
    var $this = $(this);
    var $stars = $this.siblings(".star").addBack();
    var rating = $this.data("rating");
    var $modal = $this.closest(".oceni-obrok");

    // Set rating
    $stars.removeClass("selected rated");
    $this.addClass("selected");
    $stars.each(function () {
      if ($(this).data("rating") <= rating) {
        $(this).addClass("rated");
      }
    });

    // Remove 'disabled' class and disabled attribute from the .btn-rating-confirm button
    var $confirmButton = $modal.find(".btn-rating-confirm");
    $confirmButton.removeClass("disabled").prop("disabled", false);
  });

  // Star hover effects
  $(document).on("mouseenter", ".oceni-obrok .rating-stars .star", function () {
    var $this = $(this);
    var $stars = $this.siblings(".star").addBack();
    var rating = $this.data("rating");

    // Apply hover-rated class
    $stars.removeClass("hover-rated");
    $stars.each(function () {
      if ($(this).data("rating") <= rating) {
        $(this).addClass("hover-rated");
      }
    });
  });

  $(document).on("mouseleave", ".oceni-obrok .rating-stars .star", function () {
    $(this).parent().children(".star").removeClass("hover-rated");
  });
});
